import { render } from "./GeneralStats.vue?vue&type=template&id=594d3620&scoped=true"
import script from "./GeneralStats.vue?vue&type=script&lang=js"
export * from "./GeneralStats.vue?vue&type=script&lang=js"

import "./GeneralStats.vue?vue&type=style&index=0&id=594d3620&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-594d3620"]])

export default __exports__